import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { CarrierColumnContainer } from '../../../containers/carrier-column-container';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const CarrierColumn = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { carrierId, labelProviderId } = labelFulfillment ?? {};

  if (!carrierId || !labelProviderId) {
    return '';
  }

  return <CarrierColumnContainer carrierId={carrierId} providerId={labelProviderId} />;
};

CarrierColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Carrier = {
  getMessageDescriptor: () => messages.carrier,
  id: 'carrier',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <CarrierColumn fulfillmentId={data.id} />;
  },
};
